module.exports = __webpack_public_path__ + "static/media/slider1.4d39eaf8.jpg";